import { Col, Form, FormCheck, Row } from "react-bootstrap";

const PlaylistsStartTime = (
  programDetails,
  setProgramDetails,
  setFormEdited,
  isLocked
) => {
  return (
    <Form.Group controlId="startTimeInput">
      <Row className="align-items-center pt-2 ">
        <Form.Label
          column
          sm="2"
        >
          Start Time:
        </Form.Label>
        <Col>
          <Row>
            <Col>
              <Form.Select
                value={programDetails.startTime.startTimeHours}
                size="sm"
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    startTime: {
                      ...programDetails.startTime,
                      startTimeHours: parseInt(e.target.value),
                      startTime:
                        parseInt(e.target.value) * 60 +
                        programDetails.startTime.startTimeMinutes,
                      isDirty: true,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
                className={programDetails.startTime.isDirty && "text-danger"}
              >
                {[...Array(24).keys()].map((hour) => (
                  <option
                    key={hour}
                    value={hour}
                  >
                    {hour} hrs
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col>
              <Form.Select
                value={programDetails.startTime.startTimeMinutes}
                size="sm"
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    startTime: {
                      ...programDetails.startTime,
                      startTimeMinutes: parseInt(e.target.value),
                      startTime:
                        programDetails.startTime.startTimeHours * 60 +
                        parseInt(e.target.value),
                      isDirty: true,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
                className={programDetails.startTime.isDirty && "text-danger"}
              >
                {[...Array(60 / 5).keys()].map((index) => (
                  <option
                    key={index}
                    value={index * 5}
                  >
                    {index * 5} mins
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.startTime.isDirty}
            disabled={isLocked}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                startTime: {
                  ...programDetails.startTime,
                  isDirty: e.target.checked,
                },
              });
              setFormEdited(true);
            }}
          />
        </Col>
      </Row>
    </Form.Group>
  );
};
export default PlaylistsStartTime